export default {
  BusinessStockSynchronization: {
    header: {
      warehouseCode: 'Logical Warehouse Code',
      warehouseName: 'Logical Warehouse Name',
      synchronisedTime: 'Sync Time'
    },
    table: {
      adjustCode: 'Data Sync Number',
      warehouseCode: 'Logical Warehouse Code',
      warehouseName: 'Logical Warehouse Name',
      lastUpdateName: 'Operator',
      lastUpdateDate: 'Operating Time',
    },
   review: 'review',
  }
};
